import Component from './Component';
import GameObject from '../GameObject/GameObject';
import * as PIXI from 'pixi.js';

export default class Renderable<
    U extends PIXI.Container = PIXI.Container,
    T extends GameObject<U> = GameObject<U>
> extends Component<U, T> {
    get alpha(): number {
        return this.container.alpha;
    }

    set alpha(value: number) {
        this.container.alpha = value;
    }

    get visible(): boolean {
        return this.container.visible;
    }

    set visible(value: boolean) {
        this.container.visible = value;
    }

    get cache(): boolean {
        return this.container.cacheAsBitmap;
    }

    set cache(value: boolean) {
        this.container.cacheAsBitmap = value;
    }
}
